import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-24" style={{ backgroundColor: '#FAF8F3' }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center max-w-md"
      >
        <div className="text-8xl font-playfair font-light text-charcoal-300 mb-4">404</div>
        <h1 className="text-2xl font-playfair font-semibold text-charcoal-900 mb-3">
          Page Not Found
        </h1>
        <p className="text-charcoal-600 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            style={{ backgroundColor: '#d9a79c' }}
            className="px-6 py-3 text-white rounded-2xl font-medium hover:opacity-90 transition-all shadow-soft"
          >
            Back to Home
          </Link>
          <Link
            to="/contact"
            style={{ borderColor: '#d9a79c', color: '#d9a79c' }}
            className="px-6 py-3 border-2 rounded-2xl font-medium hover:bg-rose-50 transition-all"
          >
            Contact Us
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default NotFound;
